require('dotenv').config()

const Thmesev ="v6" 

export default Thmesev;
